export default __webpack_public_path__ + "static/media/pcc.dc5b3c13.svg";